import delegate from 'delegate'
import {
  getCurrentUrl,
  getTitle,
  getBody,
  after,
  isNumber,
  isLocalLink
} from '../util/ajax_util'
import offset from 'document-offset'
import {teardownContainers, initContainers} from '../util/init'
import {languageCodes, categorySlugs} from './constants'

const overlayUrlRe = new RegExp(
  '^/(' + languageCodes.join('|') + ')/(journal|' + categorySlugs.join('|') + ')/[^/]+/?')

const homeUrlRe = new RegExp(
  '^/(' + languageCodes.join('|') + ')?/?$')

class Overlay {
  constructor () {
    this.content = document.querySelector('#overlay .overlay-content')
    this.open = document.body.matches('.state-overlay')

    window.addEventListener('keydown', e => {
      // escape key
      if (e.keyCode === 27 && this.open) {
        this.toggle(false)
      }
    })
  }
  toggle (open) {
    if (this.open !== open) {
      this.open = open
      document.body.classList[this.open ? 'add' : 'remove']('state-overlay')
    }
    return this
  }
  clear () {
    teardownContainers(this.content.children)
    this.content.innerHTML = ''
    return this
  }
  show (html) {
    if (this.content.innerHTML) {
      this.clear()
    }

    this.content.innerHTML = html
    initContainers(this.content.children)
    return this
  }
}

class LeuschkeAjaxLoader {
  constructor (initContent, menu) {
    this.contentEl = document.querySelector('#content')
    this.overlay = new Overlay()
    this.initContent = initContent
    this.menu = menu
    this.ns = 'leuschke'
    this.history = window.Modernizr.history
    this.bind()

    // contentUrl tracks what's currently in #content
    this.contentUrl = window.location.pathname

    this.loading = false
  }
  toggleLoading (isLoading) {
    if (this.loading !== isLoading) {
      this.loading = isLoading
      document.body.classList[this.loading ? 'add' : 'remove']('state-loading')
    }
  }
  closeOverlay () {
    if (!this.overlay.open) {
      return
    }
    // const anchor = this.contentUrl.split('#')[1]
    this.overlay.toggle(false)

    // if (anchor) {
    //   this.scrollToAnchor(anchor)
    // }
    this.pushState(this.contentUrl)
    this.onStateChange(this.contentUrl)
  }
  pushState (url) {
    if (this.history) {
      // only push state if it's a new page load
      window.history.pushState({ns: this.ns}, null, url)
    }
  }
  load (url, scrollTarget, state) {
    /* scrollTarget defaults to 0 if the url doesn't contain a # fragment. */
    const currentPath = getCurrentUrl().split('#')[0]
    const urlAnchor = url.split('#')[1]
    const urlPath = url.split('#')[0]
    const useOverlay = url.split('?')[0].match(overlayUrlRe)

    const changeState = () => {
      if (!state) {
        this.pushState(url)
      }
      this.onStateChange(url)
    }

    // just close the overlay if the content we want is underneath it
    if (this.overlay.open && urlPath === this.contentUrl.split('#')[0]) {
      this.overlay.toggle(false)
      if (urlAnchor) {
        this.scrollToAnchor(urlAnchor)
      }
      changeState()
      return
    }

    // scroll to local anchor if we're already on the page
    if (urlPath === currentPath && urlAnchor) {
      this.scrollToAnchor(urlAnchor)
      return
    }

    // if we're already somewhere on the homepage and there's no anchor,
    // scroll to top
    if (urlPath.match(homeUrlRe) && currentPath.match(homeUrlRe) && !urlAnchor) {
      this.scrollToAnchor(0)
      return
    }

    this.toggleLoading(true)

    if (useOverlay) {
      // open overlay so it's ready for content
      this.overlay.clear().toggle(true)
    } else {
      // ditto content
      teardownContainers(this.contentEl.children)
      this.contentEl.innerHTML = ''
    }

    if (scrollTarget === undefined && !urlAnchor && !useOverlay) {
      if (url.match(homeUrlRe)) {
        scrollTarget = 0
      } else {
        scrollTarget = offset(document.querySelector('#projects')).top
      }
    }

    let html

    const reveal = after(2, () => {
      const title = getTitle(html)
      const body = getBody(html)

      if (title) {
        document.title = title
      }

      if (useOverlay) {
        // already opened above
        this.overlay.show(body.querySelector('#overlay .overlay-content').innerHTML)
      } else {
        this.contentEl.innerHTML = body.querySelector('#content').innerHTML
        this.initContent(this.contentEl)
        this.contentUrl = url
        if (this.overlay.open) {
          this.overlay.toggle(false)
        }
      }
      this.toggleLoading(false)

      // scroll to anchor if there is one
      if (!isNumber(scrollTarget) && urlAnchor) {
        this.scrollToAnchor(urlAnchor)
      }
    })

    if (isNumber(scrollTarget)) {
      // window.scroll({
      //   top: scrollTarget
      // })
      window.scroll({
        top: scrollTarget,
        behavior: 'smooth'
      })
      setTimeout(reveal, 100)
    } else {
      reveal()
    }

    function doLoad (h) {
      changeState()
      html = h
      reveal()
    }

    const params = {
      method: 'get',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    return window.fetch(url, params).then((response) => {
      return response.text()
    }).then(doLoad)
    // .catch((err) => {
    //   console.log(err.message)
    //   window.location = url
    //   // if (xhr.status === 404) {
    //   //   doLoad(xhr.responseText)
    //   // } else {
    //   //   window.location = url
    //   // }
    // })
  }
  scrollToAnchor (target, smooth = true) {
    if (typeof target !== 'number') {
      // assume a selector
      const targetEl = document.getElementById(target)
      target = targetEl.getBoundingClientRect().top + window.scrollY
    }

    window.scroll({
      top: target,
      behavior: smooth ? 'smooth' : 'auto'
    })
  }
  onStateChange (url) {

  }
  bind () {
    if (this.history) {
      window.addEventListener('popstate', e => {
        // check state to avoid handling Crapfari's pageload popstate event
        if (e.state && e.state.ns === this.ns) {
          const url = getCurrentUrl()
          this.load(url, null, e.state)
          this.onStateChange(url)
        }
      })

      // replace original state so original loaded page works
      window.history.replaceState({ns: this.ns}, null, getCurrentUrl())
    }
  }
}

function navigation (initContent, menu) {
  const ajax = new LeuschkeAjaxLoader(initContent, menu)

  // handle all link clicks here
  // TODO target specific links maybe?
  delegate('a', 'click', e => {
    const modifier = e.shiftKey || e.ctrlKey || e.metaKey
    const link = e.delegateTarget
    const local = isLocalLink(link)

    // ignore infinite scroll next links
    if (link.matches('.next-link')) {
      return
    }

    // hard pageload if on the 404 page
    if (document.body.classList.contains('p404')) {
      return
    }

    const contentExists = document.querySelector('#content').children.length

    if (link.matches('#overlay .close') && contentExists) {
      ajax.closeOverlay()
      e.preventDefault()
      initContent()
      return
    }

    if (!modifier && local) {
      ajax.load(link.getAttribute('href'))
      menu.toggle(false)
      e.preventDefault()
    }
  })
}

export default navigation



// WEBPACK FOOTER //
// ./assets/j/src/navigation.js